module.exports = __webpack_public_path__ + "static/media/TA274_3.46d70428.png";